import { Container as MapDiv, Marker, NaverMap } from 'react-naver-maps';

import { useState } from 'react';

import { useAtomValue } from 'jotai';
import { ctpGeoAtom, dispatchCoordinates, sigGeoAtom } from '@/interfaces/geoJson';
import { areaListAtom, hcodeListAtom, selectedRegionAtom } from './RegionList';

import { deleteRegion, postRegion, regionAtom } from '@/interfaces/region';
import CustomPolygon from './CustomPolygon';
import * as _ from 'lodash';

interface CursorInfo {
  name: string;
  position: naver.maps.Point;
}

export default function CustomNaverMap() {
  const defaultZoomLevel = 8;

  const areaList = useAtomValue(areaListAtom);
  const selectedRegion = useAtomValue(selectedRegionAtom);

  const { refetch } = useAtomValue(regionAtom);
  const hcodeList = useAtomValue(hcodeListAtom);

  const [centerPosition, setCenterPosition] = useState<naver.maps.LatLng>();
  const [cursorInfo, setCursorInfo] = useState<CursorInfo>();
  const [zoomLevel, setZoomLevel] = useState<number>(0);

  const [over, setOver] = useState<number>(-1);

  const sigGeo = useAtomValue(sigGeoAtom);
  const ctpGeo = useAtomValue(ctpGeoAtom);

  const handlePolygonClick = async (hcode: string, p_area_address: string) => {
    if (areaList) {
      let sido = null;
      let sigugun = null;
      if (hcode.length > 2) {
        const target = hcode.substring(0, 2);
        sido = ctpGeo.find((fItem: any) => fItem.properties.CTPRVN_CD === target).properties.CTP_KOR_NM;
        sigugun = p_area_address;
      } else {
        sido = p_area_address;
      }
      let target = areaList.find((fItem) => fItem.hcode === hcode);

      if (target) {
        await deleteRegion(target.seq);
      } else {
        const temp = _.find(hcodeList, (v) => v === hcode);
        if (!temp) {
          const sendParam = {
            region_group_seq: selectedRegion,
            sido,
            sigugun,
            hcode,
          };
          await postRegion(sendParam);
        } else {
          alert('이미 등록된 지역 입니다.');
          return;
        }
      }
      refetch();
    }
  };

  const handleZoomLevelChange = (level: number) => {
    if (level > 10) {
      setZoomLevel(1);
    } else {
      setZoomLevel(0);
    }
  };

  const handleMouseOut = () => {
    setOver(-1);
    setCursorInfo(null);
  };

  return (
    <MapDiv style={{ width: '100%', height: '100%' }}>
      <NaverMap
        center={centerPosition}
        defaultZoom={defaultZoomLevel}
        zoom={9}
        minZoom={7}
        maxZoom={13}
        baseTileOpacity={1}
        background="white"
        tileSpare={7}
        onZoomChanged={(param) => handleZoomLevelChange(param)}
      >
        {cursorInfo && (
          <Marker
            zIndex={100}
            icon={{
              content: `<div style='width:8rem;text-align:center;position:absolute;top:0.5rem;left:0.5rem;border-radius:25px;padding:0.5rem;background:rgba(50, 100, 250, 0.8);color:#ffffff'>${cursorInfo.name}</div>`,
            }}
            position={cursorInfo.position}
          />
        )}

        {sigGeo &&
          sigGeo.length > 0 &&
          sigGeo.map((item: any, idx: number) => {
            const coord =
              item.geometry.type === 'Polygon'
                ? item.geometry.coordinates[0]
                : dispatchCoordinates(item.geometry.coordinates);
            return (
              <CustomPolygon
                key={idx}
                idx={idx}
                paths={coord}
                area_code={item.properties.SIG_CD}
                area_name={item.properties.SIG_KOR_NM}
                enableFlag={zoomLevel === 1 ? true : false}
                selected={areaList?.findIndex((fItem) => fItem.hcode === item.properties.SIG_CD) > -1}
                click={handlePolygonClick}
                mouseOver={setOver}
                mouseMove={setCursorInfo}
                mouseOut={handleMouseOut}
                over={over}
              />
            );
          })}
        {ctpGeo &&
          ctpGeo.length > 0 &&
          ctpGeo.flatMap((item: any, idx: number) => {
            const subPolygons =
              item.geometry.type === 'Polygon'
                ? [item.geometry.coordinates]
                : item.geometry.coordinates;

            return subPolygons.map((rings: any, subIdx: number) => (
              <CustomPolygon
                key={`${idx}-${subIdx}`}
                idx={idx}
                paths={rings}
                area_code={item.properties.CTPRVN_CD}
                area_name={item.properties.CTP_KOR_NM}
                enableFlag={zoomLevel === 0}
                selected={areaList?.findIndex((fItem) => fItem.hcode === item.properties.CTPRVN_CD) > -1}
                click={handlePolygonClick}
                mouseOver={setOver}
                mouseMove={setCursorInfo}
                mouseOut={handleMouseOut}
                over={over}
              />
            ));
          })}
      </NaverMap>
    </MapDiv>
  );
}
